var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-loading"},[_c('transition',{attrs:{"name":"vue-ui-fade","appear":""}},[(_vm.loading)?_c('VueLoadingIndicator',{staticClass:"primary"}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }